type PlainObject = Record<string, unknown>;
const UNSAFE_KEYS = new Set(["__proto__", "constructor", "prototype"]);

const isPlainObject = (value: unknown): value is PlainObject =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const deepMerge = <T>(base: T, override: unknown): T => {
  /* v8 ignore start */
  if (!isPlainObject(base)) return base;
  if (!isPlainObject(override)) return { ...base } as T;
  /* v8 ignore end */
  const output: PlainObject = { ...base };

  Object.entries(override).forEach(([key, value]) => {
    if (UNSAFE_KEYS.has(key)) return;

    const existing = output[key];

    if (isPlainObject(existing) && isPlainObject(value)) {
      output[key] = deepMerge(existing, value);
      return;
    }

    if (value !== undefined && value !== null) {
      output[key] = value;
    }
  });

  return output as T;
};
